module.exports = __webpack_public_path__ + "img/TECATELOGO_ROJO.9f0c111a.png";